import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsSubmissionComponent } from './leads-submission.component';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from 'src/app/public-website/public-shared/public-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';


const submissionRoutes: Routes = [
  { path: '', component: LeadsSubmissionComponent },
  { path: 'ar', component: LeadsSubmissionComponent },
  { path: 'en', component: LeadsSubmissionComponent },
];
@NgModule({
  declarations: [
    LeadsSubmissionComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(submissionRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    PublicSharedModule,

  ]
})
export class LeadsSubmissionModule { }
